<template>
  <div>
    <CRow class="mb-5">
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <div class="row">
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div v-for="(buttonGroup, index) in groupedButtons" :key="index" class="row">
              <button v-for="(button, idx) in buttonGroup" :key="idx" class="div-button col m-2 p-2 text-white"
                @click="changePage(button.page)">
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      buttons: [
        { label: "ROLES", page: "roles" ,company:[3,4,5,6]},
        { label: "CLIENTE", page: "clients" ,company:[3,4,5,6]},
        { label: "EMPRESA", page: "companies" ,company:[3,4,5,6]},
        { label: "SEDES", page: "campus" ,company:[3,4,5,6]},
        { label: "ALMACENES", page: "almacen" ,company:[3,4,5,6]},
        { label: "MODELOS", page: "model" ,company:[5]},
        { label: "MARCAS", page: "brand" ,company:[5]},
        { label: "PERSONAL", page: "personal" ,company:[3,4,5,6]},
        { label: "CAJAS", page: "boxes" ,company:[3,4,5,6]},
        { label: "METODO DE PAGO", page: "method_payment" ,company:[3,4,5,6]},
        { label: "UNIDADES", page: "units" ,company:[3,4,5,6]},
        { label: "PRODUCTO", page: "products" ,company:[3,4,5,6]},
        { label: "PROVEEDORES", page: "provider" ,company:[3,4,5,6]},
        { label: "INSUMOS", page: "inputs" ,company:[3,4,5,6]},
        { label: "KITS", page: "kits" ,company:[3,4,5,6]},
        
        // { label: "PROYECTOS", page: "projects" },
      ],
    };
  },
  computed: {
    filteredButtons() {
      const company = this.$store.getters.get_company;
      const companyId = company ? company.id : null;
      const rol = this.$store.getters.get_rol;
      const rolId = rol ? rol.id : null;

      if (this.isUserAdminHowert) {
        return this.buttons.filter(button =>
          // !(button.page == 'boxes' || button.page == 'barbers' || button.page == 'units' || button.page == 'products' || button.page == 'projects' || button.page == 'provider' || button.page == 'clients' || button.page == 'personal')
          !(button.page == 'boxes' || button.page == 'barbers' || button.page == 'units' || button.page == 'products' || button.page == 'provider' || button.page == 'clients' || button.page == 'personal')
        );
      } else {
        if (companyId == 4 && rolId == 8) {
          const allowedPages = ["units", "products", "provider", "inputs", "kits"];
          return this.buttons.filter(button =>
            allowedPages.includes(button.page) && button.company.includes(companyId)
          );
        } else if (companyId == 4 && rolId == 7) {
          const allowedPages = ["units", "products", "provider", "inputs", "kits"];
          return this.buttons.filter(button =>
            allowedPages.includes(button.page) && button.company.includes(companyId)
          );
        }
        return this.buttons.filter(button =>
          !(button.page == 'companies' || button.page == 'boxes' || button.page == 'roles') && (companyId ? button.company.includes(companyId) : false)
        );
      }
    },
    // Agrupar botones en grupos de 4
    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.filteredButtons.length; i += 4) {
        groups.push(this.filteredButtons.slice(i, i + 4));
      }
      return groups;
    },
    isUserAdminHowert() {
      const rol = this.$store.getters.get_rol;
      return rol ? rol.id == 1 : false;
    },
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    mtdBack() {
      this.$emit('setView', 'home')
    }
  },
};
</script>
<style scoped>
.btn-custom {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#div_conte {
  border: 1.5px solid #926cdc;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div>div>button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div>div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #div_conte2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  #scroll-div>div>button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div>div>button {
    height: 40px;
    font-size: 12px;
  }
}
</style>
